module.exports = __webpack_public_path__ + "img/stripe.2a962a7c.svg";